export const formatDate = (timeString) => {
const dateObj = new Date(timeString);

const options = {
  year: "numeric",
  month: "short",
  day: "numeric",
  hour: "numeric",
  minute: "numeric",
  second: "numeric",
  hour12: true
};

const outputTime = dateObj.toLocaleString("en-US", options);
return outputTime;
}